var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.175 0 0 5.175 0 11.5C0 17.825 5.175 23 11.5 23C17.825 23 23 17.825 23 11.5C23 5.175 17.825 0 11.5 0ZM12.075 4.10714C12.9786 4.10714 13.8 4.84643 13.8 5.83214C13.8 6.81786 13.0607 7.55714 12.075 7.55714C11.1714 7.55714 10.35 6.81786 10.35 5.83214C10.35 4.84643 11.0893 4.10714 12.075 4.10714ZM11.1714 19.6321C9.69286 19.6321 8.625 18.2357 9.03571 16.8393L10.5143 11.9107C10.6786 11.3357 10.2679 10.8429 9.69286 10.8429H8.95357C9.36429 9.61071 10.5143 8.78929 11.8286 8.78929C13.3071 8.78929 14.375 10.1857 13.9643 11.5821L12.4857 16.5107C12.3214 17.0857 12.7321 17.5786 13.3071 17.5786H14.0464C13.6357 18.8107 12.4857 19.6321 11.1714 19.6321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.2d75dda62bd4815c02188cd21d577bff.svg";
export { ForwardRef as ReactComponent };